export const SET_WAREHOUSE = "SET_WAREHOUSE"
export const SET_WAREHOUSE_PRODUCTS = "SET_WAREHOUSE_PRODUCTS"
